/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/drag-drop/drag-drop',['require','underscore','jquery','backbone','core/base-screen','modules/components/feedback','jqueryui'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  var BaseScreen = require('core/base-screen');
  var Feedback = require('modules/components/feedback');

  // var markdown = require('markdown');
  require('jqueryui');

  /*****************************************************************************************************************///}

  var DragDrop = BaseScreen.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    attempts: 0,
    currentContainer: -1,
    dragIndex: -1,
    dragItems: [],
    dropTargets: [],

    events: {
      'click .submit-btn': 'submitPressed'
    },

    regions: {
      feedback: '.feedback-holder'
    },

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      BaseScreen.prototype.initialize.apply(this, arguments);

      //console.log('DragDrop::initialize');

      this.dragItems = new Backbone.Collection(this.model.get('objects'));
      this.dropTargets = new Backbone.Collection(this.model.get('targets'));
    },

    onShow: function()
    {
      this.positionElements();

      this.playMedia({ callback: this.onMediaEnded });

      // make things draggable
      this.$el.find('.drag').draggable({
        containment: '[data-role=content]',
        cursor: 'move',
        scroll: false,
        start: $.proxy(this.onStartDrag, this),
        revert: $.proxy(this.onRevert, this)
        // revert: 'invalid'
      });

      this.$el.find('.drop').droppable({
        accept: '.drag',
        hoverClass: 'over',
        greedy: true,
        drop: $.proxy(this.onDrop, this)
      });

      this.$el.find('.bench').droppable({
        accept: '.drag',
        drop: $.proxy(this.checkOutside, this)
      });

      this.$el.find('.bank').droppable({ // for item bank... not using
        accept: '.drag',
        hoverClass: 'over',
        drop: $.proxy(this.checkOutside, this)
      });
    },

    positionElements: function()
    {
      var $el;

      // position drag items
      $el = this.$el.find('.bench .object');
      this.dragItems.each(function(obj, index)
      {
        if (obj.get('position'))
          $el.eq(index).css(obj.get('position'));
        else
          obj.set('position', $el.eq(index).position());
      });

      // position drop targets
      $el = this.$el.find('.bench .target');
      this.dropTargets.each(function(obj, index)
      {
        if (obj.get('position'))
          $el.eq(index).css(obj.get('position'));
        else
          obj.set('position', $el.eq(index).position());
      });
    },

    onStartDrag: function(e, ui)
    {
      //console.log('onStartDrag::firing');

      $(e.target).addClass('bigger');

      this.dragIndex = $(e.target).attr('data-index');

      var objects = this.model.get('objects');

      var dragData = objects[this.dragIndex];

      //console.log(dragData.container);
      this.currentContainer = dragData.container;

      // if this drag item is already in a drop area, break the chain (starting with its container)
      if (dragData.container)
      {
        dragData.contains = null;
        dragData.container = null;
      }

      //console.log(dragData);
    },

    onRevert: function(valid)
    {
      if (valid)
      {
        //console.log('valid');
      }
      else
      {
        this.$el.find('.drag[data-index=' + this.dragIndex + ']').removeClass('bigger');
        //console.log('not valid');
      }
      // return !valid; // this will make it revert but makes it break
    },

    onDrop: function(e, ui)
    {
      //console.log('onDrop::firing');

      var dropIndex = $(e.target).attr('data-index');
      var dragIndex = ui.draggable.attr('data-index');

      var dragData = this.dragItems.at(dragIndex);

      var self = this;

      this.dragItems.each(function(object, index)
      {
        if (object.container === dropIndex && self.currentContainer != null)
        {
          self.$el.find('.drag[data-index=' + index + ']').position({
            of: self.$el.find('.drop[data-index=' + self.currentContainer + ']'),
            using: self.animatePosition
          });
          object.container = self.currentContainer;
          object.contains = object.index;
        }
        else if (object.container === dropIndex)
        {
          self.$el.find('.drag[data-index=' + index + ']').animate({
            left: object.left,
            top: object.top
          }, 300);

          object.container = null;
        }
      });

      ui.draggable.position({ of: $(e.target) });

      dragData.container = dropIndex;
      dragData.contains = dragIndex;

      //console.log(dragData);

      var count = 0;

      this.dropTargets.each(function(target, index)
      {
        if (self.dragItems.at(index).container)
          count++;
      });

      //console.log(count);

      this.$el.find('.submit-btn').toggle(count === this.dragItems.length);
    },

    checkOutside: function(e, ui)
    {
      //console.log('checkOutside::firing');

      this.$el.find('.submit-btn').fadeOut();
    },

    submitPressed: function(e)
    {
      //console.log('submitPressed');

      this.$el.find('.submit-btn').hide();

      var self = this;

      var feedback = this.model.get('feedback') || { };

      var correct = this.evaluate();

      if (correct === this.dropTargets.length) // correct
      {
        if (!this.model.get('fire'))
        {
          this.showFeedback(feedback['correct']);
          this.finish();
        }
        else
        {
          this.fireSequence();
        }
      }
      else // incorrect
      {
        if (this.attempts >= 2)
        {
          // move and finish after 3 attempts
          this.dragItems.each(function(object, index)
          {
            if (object.correct !== true)
            {
              self.$el.find('.drag[data-index=' + index + ']').addClass('bigger');
              self.$el.find('.drag[data-index=' + index + ']').position({
                of: self.$el.find('.drop[data-index=' + index + ']'),
                using: self.animatePosition
              });
            }
          });

          if (!this.model.get('fire'))
          {
            this.showFeedback(feedback['attempts']);
            this.finish();
          }
          else
          {
            this.fireSequence();
          }
        }
        else
        {
          this.dragItems.each(function(object, index)
          {
            if (object.correct !== true)
            {
              self.$el.find('.drag[data-index=' + index + ']').animate(object.get('position'), 300);
              self.$el.find('.drag[data-index=' + index + ']').removeClass('bigger');

              object.container = null;
              object.contains = null;
            }
          });

          this.showFeedback(feedback['incorrect']);
          this.$el.find('.submit-btn').hide();

          this.attempts++;
        }
      }

      return false;
    },

    showFeedback: function(feedback, onDestroy)
    {
      onDestroy = onDestroy || _.noop;

      if (!feedback)
      {
        //console.log('Feedback not found.');
        onDestroy();
        return;
      }

      var feedbackView = new Feedback({ model: new Backbone.Model(feedback) });
      feedbackView.on('destroy', onDestroy, this);
      this.feedback.show(feedbackView);
    },

    animatePosition: function(css, calc)
    {
      $(this).animate(css, 300, 'linear');
    },

    fireSequence: function()
    {
      this.$el.find('.bench').hide();

      var feedback = this.model.get('feedback') || { };

      var neurons = $('.network').children();

      neurons.each(function(i) {
        var neuron = $(this);

        setTimeout(function() {
          neuron.addClass('highlight', function() {
            setTimeout(function() {
              neuron.removeClass('highlight');
            }, 500);
          });
        }, 500 * i);
      });

      var self = this;

      setTimeout(function() {
        self.showFeedback(feedback['correct']);
        self.finish();
      }, 4000);
    },

    evaluate: function(e, ui)
    {
      var correct = 0;
      var self = this;

      this.dragItems.each(function(object, index)
      {
        if (object.container === object.contains)
        {
          object.correct = true;
          self.$el.find('.drag[data-index=' + index + ']').draggable('disable');
          correct++;
        }
      });

      //console.log(correct);
      return correct;
    }

  /*****************************************************************************************************************///}

  });

  return DragDrop;

});

